<template>
  <div
    :style="wrapperStyle"
    @click="$emit('update:value', !value)"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <div :style="circleStyle" />
  </div>
</template>

<script>
export default {
  name: 'CSwitch',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:value'],
  data() {
    return { hover: false };
  },
  computed: {
    wrapperStyle() {
      const getBackground = () => {
        if (this.value) {
          if (this.hover) {
            return this.$colors.blue.darken1;
          }
          return this.$colors.blue.base;
        }
        if (this.hover) {
          return this.$colors.grey.lighten2;
        }
        return this.$colors.grey.lighten3;
      };
      return {
        display: 'flex',
        cursor: 'pointer',
        flexShrink: '0',
        height: '14px',
        width: '26px',
        borderRadius: '44px',
        padding: '2px',
        boxSizing: 'content-box',
        background: getBackground(),
        transition: 'background 200ms ease 0s, box-shadow 200ms ease 0s',
      };
    },
    circleStyle() {
      return {
        width: '14px',
        height: '14px',
        borderRadius: '44px',
        background: 'white',
        transition: 'transform 200ms ease-out 0s, background 200ms ease-out 0s',
        transform: this.value ? 'translateX(12px) translateY(0px)' : 'translateX(0px) translateY(0px)',
      };
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

</style>
